import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { LocalizedMessage, LocalizedStandardDateNoSeconds } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core/styles';
// Core components
import Box from 'components/core/Box';
import Link from 'components/core/Link';
import Typography from 'components/core/Typography';
// Custom
import { openDialog } from 'actions';
import { cpmOnDemandAccessForCheckoutDataShape } from 'constants/PropTypesShapes';
import { dateGenerator } from 'utils/DateUtils';
import InformationItem from 'components/items/InformationItem';

const CheckoutInfo = ({
  onDemand: { begin, priceGrid }, withPriceGrid, handleOpenDialog, theme,
}) => {
  const handleShowPriceGrid = () => {
    handleOpenDialog({
      title: {
        id: 'title.priceGrid',
      },
      actions: [{ type: 'close' }],
      component: {
        type: 'CARPARK_PRICE_GRID_INFO',
        props: {
          priceGrid,
          background: 'defaultBackground',
        },
      },
      dividers: true,
      size: 'sm',
    });
  };

  return (
    <Box type="defaultBackground">
      <div className="information-item-wrapper">
        <InformationItem
          label={(
            <Typography type="infoItemLabel">
              <LocalizedMessage id="field.entryDate" />
            </Typography>
            )}
          icon="itemDateBegin"
          iconColor={theme.palette.primary.main}
          value={(
            <Typography type="infoItemSubtitle">
              <LocalizedStandardDateNoSeconds value={dateGenerator.date(begin)} />
            </Typography>
            )}
        />
      </div>

      {/* Price grid */}
      {withPriceGrid && (
      <div className="information-item-wrapper">
        <InformationItem
          icon="btnPriceGrids"
          iconColor={theme.palette.primary.main}
          value={(
            <div className="infoItemLink">
              <Link onClick={handleShowPriceGrid}>
                <LocalizedMessage id="field.priceGridDisplay" />
              </Link>
            </div>
              )}
        />
      </div>
      )}
    </Box>
  );
};

CheckoutInfo.propTypes = {
  onDemand: cpmOnDemandAccessForCheckoutDataShape.isRequired,
  withPriceGrid: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
};

CheckoutInfo.defaultProps = {
  withPriceGrid: false,
};

const mapDispatchToProps = (dispatch) => ({
  handleOpenDialog: (props) => {
    dispatch(openDialog(props));
  },
});

module.exports = compose(connect(null, mapDispatchToProps), withTheme)(CheckoutInfo);



// WEBPACK FOOTER //
// ./routes/checkout/components/CheckoutInfo.js